/* src/app/reconciliation/reconciliation-share-template-popup/reconciliation-share-template-popup.component.scss */
body#themeTag :host ::ng-deep p-footer .p-toolbar > * {
  flex-basis: 65px;
}
body#themeTag :host ::ng-deep form .p-multiselect {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-dialog-content {
  min-height: 10.25em;
}
/*# sourceMappingURL=reconciliation-share-template-popup.component.css.map */
